import React from "react";
import { addParamUrl } from "../../../../utils";

export function TwoocaErrorCardModal(props) {
  function redirectMyPage() {
    window.location.href = addParamUrl("/mypage");
  }

  return (
    <div
      className={
        props.showing
          ? "custom-modal-container group-special-gochi-kid-modal gochi-kid-preview-image-receipt-modal twooca-error-card-modal show-modal"
          : "custom-modal-container group-special-gochi-kid-modal gochi-kid-preview-image-receipt-modal twooca-error-card-modal"
      }
      size="sm"
    >
      <div
        className={
          props.showing
            ? "modal modal-action modal-dialog is-show history-modal"
            : "modal modal-action modal-dialog history-modal"
        }
      >
        <div className="modal-header-history">
          <button
            className="modal-btn modal-btn-close"
            id="modalClose"
            onClick={() => props.onClose()}
            type="button"
          >
            <svg className="icon">
              <title>閉じる</title>
              <use xlinkHref="/assets/img/common/icon.svg#times" />
            </svg>
          </button>
        </div>
        <div className="title-modal title-modal-charge">
          <div className="title required-dot">
            <div className="dot-red"></div>
            カード番号未登録
          </div>
        </div>
        <div className={`modal-body`}>
          こどもごちめしでTwooCaチャージを行うために、
          <span className="color-EC4A56">TwooCaアカウントの登録・連携</span>
          、及びTwooCaアプリで
          <span className="color-EC4A56">
            「リアルVisaカード（プリペイドカード）」の発行
          </span>
          をお願いいたします。
          <br />
          <br />
          恐れ入りますが、お客様のTwooCaアカウントでは有効なカード番号が確認できませんでした。
          <br />
          お手数ですが、TwooCaアプリを起動し、メニューからリアルVisaカード（プリペイドカード）の発行手続きを行ってください。
          <br />
          <br />
          【注意事項】
          <ul>
            <li>
              カード番号が発行され、有効化されるまでチャージ機能はご利用いただけません。
            </li>
            <li>
              リアルVisaカードはお申し込みからお手元に届くまで2〜3週間程度かかります。お早めの発行手続きをお願いいたします。
            </li>
            <li>チャージは反映まで時間がかかる場合があります。</li>
          </ul>
          システムエラー等により完了が遅れることもあるため、ご利用前に余裕をもってチャージを行ってください。
          <br />
          <br />
          各種サポートページURL掲載TwooCaマイページ：
          <br />
          <a href="/mypage/twooca">https://gochi.online/mypage/twooca</a>
        </div>
        <div className="modal-footer">
          <button
            className="btn btn-rect btn-submit"
            onClick={() => redirectMyPage()}
          >
            GOCHIマイページへ
          </button>
        </div>
      </div>
      <div className="back-drop" />
    </div>
  );
}
